export default __webpack_public_path__ + "static/media/tickIcon.b85f7e86.svg";